"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const moment_1 = __importDefault(require("moment"));
const ControlRendererContext_1 = __importDefault(require("../../../ControlRendererContext"));
const valueIsUndefined_1 = __importDefault(require("../../../typeAssertions/valueIsUndefined"));
const valueIsNotUndefined_1 = __importDefault(require("../../../typeAssertions/valueIsNotUndefined"));
const useControlEvents_1 = __importDefault(require("../../../hooks/useControlEvents"));
const controlStyleToAtomStyle_1 = __importDefault(require("../../../shared/controlStyleToAtomStyle"));
const dateIconStyle = {
    position: 'absolute',
    left: 0,
    top: 4,
    marginLeft: 0,
};
const dateFormat = {
    date: 'DD-MM-YYYY',
    datetime: 'DD-MM-YYYY HH:mm:ss a',
    time: 'HH:mm:ss a',
};
const dateOptions = {
    time: {
        minDate: '01:00:00',
        maxDate: '23:59:59',
    },
    date: {
        minDate: '01-01-1000',
        maxDate: '01-01-3000',
    },
    datetime: {
        minDate: '01-01-1000 01:00:00',
        maxDate: '01-01-3000 23:59:59',
    },
};
const DatePickerRender = ({ dateControl, }) => {
    var _a;
    const { Render, functions: { processor }, getColorFromSpecification, globalFontSize, } = (0, react_1.useContext)(ControlRendererContext_1.default);
    const events = (0, useControlEvents_1.default)(dateControl);
    const setDateFormat = (0, react_1.useCallback)((date) => {
        const defaultFormat = dateFormat[dateControl.modeDate || 'date'];
        return (0, moment_1.default)(date, defaultFormat).format(dateControl.dateFormat);
    }, [dateControl.dateFormat, dateControl.modeDate]);
    const currentDate = (0, react_1.useMemo)(() => setDateFormat(new Date()), [setDateFormat]);
    const onDateChange = (0, react_1.useCallback)((date) => {
        if (processor) {
            const newDate = setDateFormat(date);
            processor.root.updateControlById({
                control: dateControl,
                dataToUpdate: {
                    date,
                    value: newDate,
                },
            });
            if (events === null || events === void 0 ? void 0 : events.onDateChange) {
                events.onDateChange(newDate);
            }
        }
    }, [processor, dateControl, setDateFormat, events]);
    (0, react_1.useEffect)(() => {
        if ((0, valueIsUndefined_1.default)(dateControl.value) && (0, valueIsNotUndefined_1.default)(processor)) {
            processor.root.updateControlById({
                control: dateControl,
                dataToUpdate: {
                    value: currentDate,
                },
            });
        }
    }, [dateControl, currentDate, processor]);
    const atomStyle = (0, controlStyleToAtomStyle_1.default)({
        getColorFromSpecification,
        globalFontSize,
        style: (_a = dateControl.style) !== null && _a !== void 0 ? _a : {},
    });
    const datePickerStyle = (0, react_1.useMemo)(() => ({
        width: atomStyle.width,
        height: atomStyle.height,
        backgroundColor: atomStyle.backgroundColor,
        color: atomStyle.color,
        borderColor: atomStyle.borderColor,
    }), [atomStyle]);
    const dateInputStyle = (0, react_1.useMemo)(() => ({
        borderColor: atomStyle.borderColor,
        borderTopWidth: atomStyle.borderTopWidth,
        borderBottomWidth: atomStyle.borderBottomWidth,
        borderRightWidth: atomStyle.borderRightWidth,
        borderLeftWidth: atomStyle.borderLeftWidth,
    }), [atomStyle]);
    const dateTextStyle = (0, react_1.useMemo)(() => ({
        color: atomStyle.color,
        textAlign: atomStyle.textAlign || 'center',
        fontSize: atomStyle.fontSize,
    }), [atomStyle]);
    return (react_1.default.createElement(Render.DatePicker, { style: datePickerStyle, date: dateControl.value || currentDate, mode: dateControl.modeDate || 'date', placeholder: "select date", showIcon: false, format: dateFormat[dateControl.modeDate || 'date'], minDate: dateOptions[dateControl.modeDate || 'date'].minDate, maxDate: dateOptions[dateControl.modeDate || 'date'].maxDate, customStyles: {
            dateIcon: dateIconStyle,
            dateInput: dateInputStyle,
            dateText: dateTextStyle,
        }, onDateChange: onDateChange }));
};
exports.default = DatePickerRender;
